export default function addWaterMark(lang = "zh-CN") {
  const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
  const strArr1 =
    `${lang == "en" ? userInfo.userId+userInfo.userEname : userInfo.userId + userInfo.userName}`;
  const currentDate = new Date().toString();
  const strArr2 = currentDate.replace(/GMT.+$/, "");
  let ctx = document.createElement("canvas");
  ctx.width = 450;
  ctx.height = 170;
  ctx.style.display = "none";
  let cans = ctx.getContext("2d");
  cans.rotate(-0.2);
  cans.font = "12px Mincrosoft YaHei";
  cans.translate(100,120);
  cans.fillStyle = "rgba(17,17,17,0.2)";
  // cans.fillStyle = "rgba(0,0,0)";
  cans.textAlign = "left";
  cans.textBaseline = "middle";
  cans.fillText(strArr1, 0, 50);
  cans.fillText(strArr2, 0, 70);
 
  cans.save();
  return ctx.toDataURL();
}



// WEBPACK FOOTER //
// ./src/util/watermark.js